const createComponentModule = require('../../../common/utils/createComponentModule');

function createHandleEyeClick(component) {
  const passwordInput = component.querySelector('.field-password__input');
  return (event) => {
    event.target.classList.toggle('field-password__eye--uncrossed');
    passwordInput.type =
      passwordInput.type === 'password' ? 'text' : 'password';
  };
}

module.exports = createComponentModule(
  '.field-password',
  (fieldPasswordComponent) => {
    const eyeButton = fieldPasswordComponent.querySelector(
      '.field-password__eye'
    );
    eyeButton.addEventListener(
      'click',
      createHandleEyeClick(fieldPasswordComponent)
    );
  }
);
